export const PRODUCT_ISN = {
  kasko: [
    '829151',
    '952731',
    '878101',
    '2043',
    '606041',
    '1999591',
    '771731',
    '482131',
    '711141',
    '1864161',
    '482121',
    '425651',
    '1932231',
    '481821',
    '1959701',
    '1893471',
    '1878821',
    '863291',
    '1946181',
    '1946151',
    '1933941',
    '1880321',
    '2142831',
    '873111',
    '2142661',
  ],
  osago: ['1935171', '3387'],
  ipoteka: [
    '326601',
    '744731',
    '744741',
    '327031',
    '831711',
    '326621',
    '318831',
    '950391',
    '306621',
  ],
  dms: ['200180', '383721', '324041'],
  tick: ['697701', '361331', '757001', '767161'],
  'dms-migrants': [
    '390981',
    '781681',
    '613131',
    '390961',
    '1948091',
    '632331',
    '686731',
    '1991811',
    '827561',
    '621941',
  ],
  'foreign-students': ['755541', '851051', '954061'],
  accident: [
    '800751',
    '803171',
    '762921',
    '700741',
    '632151',
    '632161',
    '697781',
    '651131',
    '632171',
    '836311',
    '1257211',
    '956991',
    '949771',
    '712951',
    '875061',
    '875081',
    '875071',
    '874201',
    '776621',
    '776091',
    '772601',
    '951391',
    '776111',
    '851771',
    '1945621',
    '712971',
    '439821',
    '619941',
    '619951',
    '799841',
    '307001',
    '871441',
    '780831',
    '827771',
    '708991',
    '2014881',
    '2010501',
    '853191',
    '757031',
    '861951',
    '657331',
    '757581',
    '642531',
    '715331',
    '699951',
    '802511',
    '870591',
    '306581',
    '306611',
    '768411',
    '363481',
    '363511',
    '639161',
    '363571',
    '311711',
    '363521',
    '327881',
  ],
  apartment: [
    '750531',
    '750731',
    '750751',
    '396401',
    '605331',
    '697931',
    '1937121',
    '653531',
    '775801',
    '478371',
    '778331',
    '632141',
    '833601',
  ],
  covid: ['956391'],
  vzr: ['200170', '304011', '1931191', '614251', '768551', '803951'],
}
